<h1 mat-dialog-title [title]="title | translate">
    {{ title | translate }}
</h1>
<div mat-dialog-content>
    <iframe [src]="sanitizedUrl" class="preview-frame"
            allow="autoplay; fullscreen; encrypted-media">
    ></iframe>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="onClose()">Close</button>
</div>
